var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('one-button-toggle',{staticClass:"one-tax-switcher-component",attrs:{"value":_vm.isHidePrices,"is-text":"","active-text":_vm.$t('header.hide_prices'),"in-active-text":_vm.$t('header.hide_prices')},on:{"change":function($event){return _vm.setHiddenPrices($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }